export const config = {
  baseUrl: import.meta.env.VITE_API || "http://localhost:3000",
  apiUrl: import.meta.env.VITE_API_URI || "http://localhost:3000/api/v1",
  cookie: {
    cookieDomain: import.meta.env.VITE_COOKIE_DOMAIN,
  },
  env: import.meta.env.VITE_NODE_ENV ?? 'development',
};
